module.exports = "/out/d0c099fcf0e77ad50e0631e0acfa8915.svg";